// Presentación del uso del asistente por proyecto (estado que calcula el script 50).

export const LEVELS = {
  ok: { tone: 'live', label: 'Normal' },
  warn: { tone: 'caution', label: 'Cerca del límite' },
  over: { tone: 'caution', label: 'Pasó el límite (solo aviso)' },
  limit: { tone: 'signal', label: 'Límite alcanzado' },
  blocked: { tone: 'signal', label: 'Pausado' },
};

/** Etiqueta y tono de un proyecto: sin plan ni topes no tiene límite, solo se mide. */
export function levelOf(p) {
  if (!p?.has_plan && !p?.blocked) return { tone: 'neutral', label: 'Sin límite' };
  return LEVELS[p.level] || LEVELS.ok;
}

/** Qué se pasó, en palabras. */
export function reasonText(p) {
  if (p?.blocked) return p.block_reason ? `Pausado: ${p.block_reason}` : 'Pausado a mano';
  return { text: 'Mensajes de texto', voice: 'Minutos de voz', text_voice: 'Mensajes y voz', cost: 'Tope en USD' }[p?.reason] || '';
}

/** Porcentaje (0 a 100) de un tope, o null si no hay tope. */
export function pctOf(used, limit) {
  if (limit == null) return null;
  if (Number(limit) === 0) return 100;
  return Math.min(100, Math.round((Number(used) || 0) / Number(limit) * 100));
}

export const usd = (v) => `$${(Number(v) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Resumen del tablero: costo del mes, clientes en límite, cerca y solicitudes. */
export function summarize(rows = []) {
  return rows.reduce((acc, p) => {
    acc.cost += Number(p?.cost?.used) || 0;
    if (p.level === 'limit' || p.level === 'blocked') acc.stopped += 1;
    else if (p.level === 'warn' || p.level === 'over') acc.near += 1;
    if (p.pending_request) acc.requests += 1;
    return acc;
  }, { cost: 0, stopped: 0, near: 0, requests: 0 });
}

/** Filtro de la lista. */
export function matches(p, filter, q) {
  const text = (q || '').trim().toLowerCase();
  if (text && !`${p.name || ''} ${p.plan_name || ''} ${p.project_id}`.toLowerCase().includes(text)) return false;
  if (filter === 'stopped') return p.level === 'limit' || p.level === 'blocked';
  if (filter === 'near') return p.level === 'warn' || p.level === 'over';
  if (filter === 'noplan') return !p.has_plan && !p.blocked;
  return true;
}
